import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { Button } from "@/ui/Button"
import { IButtonRing } from "."
import styles from "./ButtonRing.module.scss"

export const ButtonRing: FC<PropsWithChildren<IButtonRing>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Button
      id="ring-button"
      className={clsx(styles.ButtonRing, className)}
      triangleTopPosLeft="40%"
      triangleBottomPosLeft="none"
      {...props}
    >
      {children}
    </Button>
  )
}
